import Repository from './Repository.js';

/**
 * Data manipulation functionality for imported items.
 *
 * @memberOf module:project/Common
 * @extends module:project/Common.Repository
 * @version 1.0.0
 * @author Rocco Janse <rocco.janse@valtech.nl>
 */
class FilterRepository extends Repository {
    /**
     * Overwrites data from super Repository.
     * @param {object} options
     */
    constructor(options) {
        super(options);

        // data to send with api calls
        this.data = $.extend(true, this.data, this.options.data);
        this.orgData = $.extend(true, {}, this.options.data);

        if (this.qsParams) {
            this.data.SelectedTags = this.qsParams;
        }
    }

    /**
     * Fetches all available items
     * @param {object} data Data to extend ajax request with.
     */
    getAllItems(data) {
        this.emit('beforeInit');

        // add filtering in root level of POST vars
        if (typeof data.SelectedTags !== 'undefined') {
            data = $.extend(true, data, data.SelectedTags);
        }

        // reset data
        this.data = $.extend(true, {}, this.orgData);

        // extend data with guid
        //data.Item = this.data.Item;
        this.data = $.extend(true, this.data, data);

        if (typeof data.SelectedTags !== 'undefined') {
            this.data.SelectedTags = data.SelectedTags;
            this.data.Tags = data.SelectedTags;
        }

        this.data.Page = 1;
        delete this.data.Filters;
        delete this.data.Items;

        if (this.options.connexysLang) {
            this.data.ConnexysLanguage = this.options.connexysLang;
        }

        if (this.options.publicationName) {
            this.data.PublicationName = this.options.publicationName;
        }

        this.ajax
            .request({
                url: '/' + this.options.lang + '/' + this.options.apiBase,
                data: JSON.stringify(this.data),
            })
            .then((response) => {
                // store items
                this.data = $.extend(this.data, response);
                this.emit('init', this.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }
}

export default FilterRepository;
